
import AppHeader from "@/components/AppHeader.vue";
import SidebarMenuAkahon from "@/components/sidebar/AkahonSideMenu.vue";
import update from "@/mixins/update";

import { useSettings } from "@/store/user";

import { watch } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: "App",
  setup() {
    const user = useSettings();
    const route = useRoute()

    watch(() => route.path, () => {
      user.updateData();
    });

    return { user };
  },
  data() {
    return {
      email: null,
      password: null,
      errors: [],
    };
  },
  mixins: [update],
  components: {
    AppHeader,
    SidebarMenuAkahon
  },
  methods: {
  },
};
